import { Check, X } from '@chain-zen/ui'

/**
 * StatusIcon component to display based on the value
 */
export const StatusIcon = ({ isPositive }: { isPositive: boolean }) => {
  const IconComponent = isPositive ? Check : X
  return (
    <IconComponent
      className={`h-4 w-4 ${isPositive ? 'text-green-500 dark:text-green-400' : 'text-red-500 dark:text-red-400'}`}
    />
  )
}
